import {compose} from "redux"
import React from "react";
import PropTypes from "prop-types";

import {Button,LoadingSpinner,CustomInput} from "../../components"
import { withFirestore,firestoreConnect,isLoaded } from 'react-redux-firebase'
import { connect } from 'react-redux'

import { withStyles,
        Paper,
        Input,
        Typography,
        Card,
        FormControl} from "@material-ui/core";
import validate from '../../actions/validateWrapper';
import axios from 'axios';
import { doesNotReject } from "assert";
// import Card from '@material-ui/core/Card';
// import CardActionArea from '@material-ui/core/CardActionArea';
// import CardMedia from '@material-ui/core/CardMedia';


var organisationId;

class EditOrganisation extends React.Component {

    state={

        isSaving:false,
        isLoading:false,
        organisation:{},
        selectedFile:null,
        error:null,
        text:"",
        text1:"",
        text2:"",
        textError:"",
        textError1:"",
        textError2:"",
        img:"",
        choosen:null,
        file: null
        
    }

    constructor(props){
        super(props)
        organisationId = this.props.route.match.params.id
        //this.fileupload = this.fileupload.bind(this)
    }

    filechoosen = event  => {
        let choosen = event.target.files[0];
        this.setState({
            selectedFile: event.target.files[0],
            file: URL.createObjectURL(event.target.files[0]),
            choosen:choosen,
            isLoading:true,
        }, () => {
            this.fileupload();
        });
        console.log(this.state.file,"check",event.target.files[0]);
    }

    fileupload = () => {
        const {firebase} = this.props
        const {img,organisation} = this.state
        var defaultStorage = firebase.storage();
        const fdata =  new FormData();
        fdata.append('image', this.state.selectedFile, this.state.selectedFile.name);
        axios.post('https://us-central1-ispani-a392c.cloudfunctions.net/uploadFile', fdata, {
            onUploadProgress: progressEvent => {
                console.log("Upload Progress:"+ Math.round(progressEvent.loaded / progressEvent.total*100)+"%")
            }
        })
        .then(res => {
            //console.log(res);
            const image = firebase.storage().ref().child(this.state.selectedFile.name);
            //console.log('pic',image);
            image.getDownloadURL().then((url) => { 
                console.log("url link needed",`${url}`);
                let organisation = this.state.organisation
                organisation.avatarUrl = `${url}`
                this.setState({organisation:organisation,img: url,isLoading:false})
            });
            //console.log("url",{img});
            //?event.target.value:`${img}`
        }).catch((error) => {
            console.log("error",error);                         
    });
    }

    saveOrganisation=()=>{
        const {firestore,history} = this.props
        const {organisation} = this.state

        var textError
        if(organisation.name==""){
        textError = validate('text', this.state.organisation.name)
        }
        else if(!this.state.text==""){
        textError = validate('text', this.state.text)
        }
        console.log("pulled",this.state.text1);
        var textError1
        if(organisation.description==""){
        textError1 = validate('text', this.state.organisation.description)
        }
        else if(!this.state.text1==""){
        textError1 = validate('text', this.state.text1)
        }
        console.log("pulled",this.state.text2);
        var textError2
        if(organisation.avatarUrl==""){
        textError2 = validate('text', this.state.organisation.avatarUrl)
        }
        else if(!this.state.text2==""){
        textError2 = validate('text', this.state.text2)
        }

        this.setState({textError:textError})
        this.setState({textError1:textError1})
        this.setState({textError2:textError2})

        if ( !textError&&!textError1&&!textError2) {
        this.setState({isSaving:true})
        firestore.update({collection:"organisations",doc:organisationId},organisation).then(()=>{
            history.goBack();
        })
    }

    }





    render(){

        const {classes,organisation} = this.props
        const {isSaving,selectedFile,isLoading} = this.state;
        console.log("Everything currently available",this.props);
        console.log("the org itself",organisation);
        return(
            <div className={classes.root}>
                <Paper style={{height:"100%"}} className={classes.container}>
                    <div className={classes.header}>
                        {isSaving?
                            <LoadingSpinner/>:
                            isLoading?
                            <Button disabled={true} color="primary" onClick={this.saveOrganisation}>Save</Button>
                            :
                            <Button color="primary" onClick={this.saveOrganisation}>Save</Button>
                            

                        }
                    </div>

                    <FormControl fullWidth={true}>
                    <Input
                        //value={organisation&&organisation.name?organisation.name:""}
                        style={{color:"#fc824e"}}
                        defaultValue={organisation&&organisation.name?organisation.name:"Untitled Organisation"}
                        className={classes.organisationHeaderInput}
                        inputProps={{
                            'aria-label': 'Organisation Title',
                            onChange:(event)=>{
                                let organisation = this.state.organisation
                                organisation.name = event.target.value
                                let text = event.target.value
                                this.setState({organisation:organisation,
                                text : text,
                                textError: validate('text', this.state.organisation.name)
                                })}
                        }}
                    />
                    {this.state.textError ? <Typography style={styles.errorColor}>{this.state.textError}</Typography> : null}
                    </FormControl>

                    <CustomInput
                        //value={organisation&&organisation.description?organisation.description:""}
                        labelText="Organisation Description"
                        inputProps={{
                            defaultValue:organisation&&organisation.description?organisation.description:"",
                            'aria-label': 'Organisation Description',
                            onChange:(event)=>{
                                let organisation = this.state.organisation
                                organisation.description= event.target.value
                                let text1 = event.target.value
                                console.log("edited",text1);
                                this.setState({organisation:organisation,
                                text1 : text1,
                                textError1: validate('text', this.state.organisation.description)
                                })}
                        }}

                        formControlProps={{
                            fullWidth: true
                        }}
                        error={this.state.textError1}
                    />

                    <CustomInput
                        //value={organisation&&organisation.avatarUrl?organisation.avatarUrl:""}
                        labelText="Avatar URL"
                        inputProps={{
                            defaultValue:organisation&&organisation.avatarUrl?organisation.avatarUrl:"",
                            'aria-label': 'Organisation Avatar',
                            onChange:(event)=>{
                                //console.log("organisation in avatarurl",organisation.avatarUrl);
                                let organisation = this.state.organisation
                                organisation.avatarUrl= event.target.value
                                let text2 = event.target.value
                                this.setState({organisation:organisation,
                                text2:text2,
                                textError2: validate('text', this.state.organisation.avatarUrl)
                                })}
                        }}

                        formControlProps={{
                            fullWidth: true
                        }}
                        error={this.state.textError2}
                    />
                    
                    <Card className={classes.card}>
                    {/* {organisation&&organisation.avatarUrl?<img src={this.state.file} width="75%"></img>:<img src={this.state.file}/>} */}
                    <img src={organisation&&organisation.avatarUrl?organisation.avatarUrl:this.state.file} width="75%"></img>
                    </Card>
                    {/* <Button color="primary" onClick={this.fileupload}>Upload Image</Button> */}
                    <input style={{display:'none'}} type="file" onChange={this.filechoosen} ref={inputFile => this.inputFile = inputFile}/>
                    {!isLoading?
                 <Button color="primary" onClick={() => this.inputFile.click()}>Upload Image</Button>
                :
                <LoadingSpinner/>
                }


                </Paper>

            </div>
        )
    }
}

const styles ={
    root:{
        display:"flex",
        justifyContent:"center",
        marginTop:20
    },
    organisationHeaderInput:{
        fontSize:40,
        width:"100%",
    },

    container:{
        width:"50%",
        minWidth:300,
        padding:60
    },
    header:{
        display:"flex",
        justifyContent:"flex-end"

    },
    errorColor: {
        marginRight: "auto",
        color:"#f44336",
    },
    card:{
        width:200,
        height:200,
        justifyContent:"center",
        //margin:20,
        boxShadow: "none",
    },


}

export default compose(
    withFirestore,
    withStyles(styles),
)(EditOrganisation)


// WEBPACK FOOTER //
// ./src/views/Organisations/EditOrganisation.jsx